import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import toast from "react-hot-toast";
import { useAddwhatsappNotificationCredentialForTenantMutation, useUpdatewhatsappNotificationCredentialForTenantMutation } from "../../../features/tenant/whatappNotificationCredential/whatsappNotificaitonCredentialApi";

const providerArray = [
  {
    id: 1,
    name: "gupshup",
    form: {
      name: ["user_id", "password"],
      view_name: ["User Id", "Password"],
    },
  },
  {
    id: 2,
    name: "pinnacle",
    form: {
      name: ["user_id", "password", "api_key"],
      view_name: ["User Id", "Password", "Api key"],
    },
  },
  {
    id: 3,
    name: "wbbox",
    form: {
      name: ["user_id", "password", "api_key", "channel_number"],
      view_name: ["User Id", "Password", "Api key", "Channel Number"],
    },
  },
  {
    id: 3,
    name: "icpaas",
    form: {
      name: ["user_id", "password", "api_key", "channel_number"],
      view_name: ["User Id", "Password", "Api key", "Channel Number"],
    },
  },
];


const AddWhatsappNotificationCredential = () => {
  const navigate = useNavigate();
  const location = useLocation();


  console.log("location ", location);
  const isUpdate = location && location.state ? location.state.edit : false;
  const [selectCredType, setSelectCredType] = useState(0);
  const [formData, setFormData] = useState({});
  const [userId, setUserId] = useState(isUpdate ? location.state.data.api_credential.user_id : null);
  const [password, setPassword] = useState(isUpdate ? location.state.data.api_credential.password : null);

  const [
    addwhatsappNotificationCredentialForTenant,
    {
      data: addwhatsappNotificationCredentialForTenantData,
      isError: addwhatsappNotificationCredentialForTenantIsError,
      error: addwhatsappNotificationCredentialForTenantError,
      isLoading: addwhatsappNotificationCredentialForTenantIsLoading,
    },
  ] = useAddwhatsappNotificationCredentialForTenantMutation();

  const [
    updatewhatsappNotificationCredentialForTenant,
    {
      data: updatewhatsappNotificationCredentialForTenantData,
      isError: updatewhatsappNotificationCredentialForTenantIsError,
      error: updatewhatsappNotificationCredentialForTenantError,
      isLoading: updatewhatsappNotificationCredentialForTenantIsLoading,
    },
  ] = useUpdatewhatsappNotificationCredentialForTenantMutation();

  const handleAddWhatsappNotificationCredential = (e) => {
    e.preventDefault();
    let allFieldAdded = false;

    for (const [key, value] of Object.entries(formData)) {
      console.log(key, value);
      if (value === null || value === "") {
        allFieldAdded = true;
      }
    }
    if (allFieldAdded || Object.keys(formData).length < providerArray[selectCredType].form.name.length) {
      toast.error("Please Enter field ", {
        id: "field error "
      });
      return;
    }

    addwhatsappNotificationCredentialForTenant({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        api_credential: formData,
        type: providerArray[selectCredType].name == "gupshup" ? "normal" : providerArray[selectCredType].name,
      },
    });
  };


  useEffect(() => {
    if (addwhatsappNotificationCredentialForTenantData) {
      toast.dismiss();
      toast.success(`${addwhatsappNotificationCredentialForTenantData.message}`, {
        id: `addwhatsappNotificationCredentialForTenantData`,
      });
      navigate(-1);
    }
    if (addwhatsappNotificationCredentialForTenantError) {
      toast.dismiss();
      toast.success(`${addwhatsappNotificationCredentialForTenantError.data.message}`, {
        id: `addwhatsappNotificationCredentialForTenantError`,
      });
    }
  }, [addwhatsappNotificationCredentialForTenantData, addwhatsappNotificationCredentialForTenantError]);

  const handleUpdate = (e) => {
    e.preventDefault()
    let allFieldAdded = false;

    for (const [key, value] of Object.entries(formData)) {
      console.log(key, value);
      if (value === null || value === "") {
        allFieldAdded = true;
      }
    }
    if (allFieldAdded || Object.keys(formData).length < providerArray[selectCredType].form.name.length) {
      toast.error("Please Enter field ", {
        id: "field error "
      });
      return;
    }

    updatewhatsappNotificationCredentialForTenant({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      id: location.state.data.id,
      body: {
        api_credential: formData,
        type: providerArray[selectCredType].name == "gupshup" ? "normal" : providerArray[selectCredType].name,
      },
    })

  }

  useEffect(() => {
    if (isUpdate) {
      let temp = {};
      console.log("location", location);
      location &&
        Object.keys(location?.state?.data.api_credential).length > 0 && Object.keys(location?.state?.data.api_credential).map((x) => {
          temp[x] = location.state.data.api_credential[x];
        });

      let credType = providerArray.find(el => el.name == location.state.data.type)
      console.log("credType", credType)
      if (credType) {
        setSelectCredType(credType.id - 1)
      }

      setFormData({ ...temp });
    }
  }, [location]);



  useEffect(() => {
    if (updatewhatsappNotificationCredentialForTenantData) {
      toast.dismiss();
      toast.success(`${updatewhatsappNotificationCredentialForTenantData.message}`, {
        id: `updatewhatsappNotificationCredentialForTenantData`,
      });
      navigate(-1);
    }
    if (updatewhatsappNotificationCredentialForTenantError) {
      toast.dismiss();
      toast.success(`${updatewhatsappNotificationCredentialForTenantError.data.message}`, {
        id: `updatewhatsappNotificationCredentialForTenantError`,
      });
    }
  }, [updatewhatsappNotificationCredentialForTenantData, updatewhatsappNotificationCredentialForTenantError]);

  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full ">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            {isUpdate ? "Update " : "Add "}
            SMS Credential
            <LinksComponent />
          </div>
          <div className="p-3 ">
            <form className="p-3 bg-white shadow rounded-lg" onSubmit={(e) => {
              isUpdate ? handleUpdate(e) : handleAddWhatsappNotificationCredential(e)
            }}>
              <div className="w-full flex justify-center space-x-3 ">
                <div className="mb-6 w-1/4">
                  <div className="w-full">
                    <label className="block text-sm font-medium leading-6 text-gray-900 mb-0">&nbsp;</label>
                    <select
                      type="text"
                      className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm h-auto rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  "
                      placeholder="Add new UserType"
                      value={selectCredType}
                      onChange={(e) => setSelectCredType(Number(e.target.value))}
                    >
                      {providerArray &&
                        providerArray.map((x, index) => {
                          if (isUpdate) {
                            if (x.id == Number(selectCredType) + 1) {
                              return (
                                <option key={x.id} value={Number(index)}>
                                  {x.name}
                                </option>
                              );
                            }
                            return;
                          } else {
                            return (
                              <option key={x.id} value={Number(index)}>
                                {x.name}
                              </option>
                            );
                          }
                        })}
                    </select>
                  </div></div>

                {providerArray &&
                  providerArray.length > 0 &&
                  providerArray[Number(selectCredType)]?.form?.name.map(
                    (x, index) => {
                      return (
                        <>
                          <div key={index} className="mb-6 w-1/4">
                            <div className="w-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900 mb-0" for="name">
                                {" "}
                                {
                                  providerArray[selectCredType]?.form.view_name[
                                  index
                                  ]
                                }{" "}
                              </label>
                              <input
                                name={x}
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  "
                                value={
                                  Object.keys(formData).length > 0
                                    ? formData[x]
                                    : ""
                                }
                                onChange={(e) => {
                                  let data = {};
                                  data[e.target.name] = e.target.value;
                                  setFormData({ ...formData, ...data });
                                }}
                                type="text"
                              />
                            </div>
                          </div>{" "}
                        </>
                      );
                    }
                  )}


              </div>
              <div className="flex justify-center mt-2">
                {isUpdate ? (
                  <button
                    type="submit"
                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                  >
                    Update
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                  >
                    Add
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddWhatsappNotificationCredential;
